<template>
  <div class="menuBar-container">
    <!-- 重要通知 -->
    <div class="notice">
      <div class="header-panel-button"
           style="position: absolute;top: .2rem;left: 15rem;">
        <el-button icon="el-icon-top-left"
                   size="small"
                   round
                   @click="handleReturn">返回省平台</el-button>
      </div>
      <!-- <transition name="slide">
        <div
          class="notice-content"
          :key="text.id"
          @click="goAnnounceNews(text.id)"
        >
          <img class="notice-img" src="../assets/images/home/notice-icon.png" />
          <span class="notice-text">{{ text.val }}</span>
        </div>
      </transition> -->
      <!-- <div class="loginBar" v-if="isSignIn">
        <div class="user-icon-wrapper" >
          <img src="../assets/images/home/user-icon.png" alt=""  />
        </div>
        <a href="javascript:;" @click="handleLogin">登录</a>
        <div class="loginBar-devider" ></div>
        <a href="javascript:;" @click="handleRegister">注册</a>
      </div> -->
      <div class="userBar">
        <div class="user-icon-wrapper">
          <img src="../assets/images/home/user-icon.png"
               alt="">
        </div>
        <a href="https://gbpx.gd.gov.cn/gdceportal/study/myinfo.aspx">{{form.name}}</a>
        <div class="loginBar-devider"></div>
        <a href="javascript:;"
           @click="SignOut">退出</a>
      </div>
    </div>
    <div class="topWrap">
      <div class="head-title-wrapper"
           style="position: relative;left: 10rem;letter-spacing: .6rem;">
        <div class="logo-wrapper"
             style="position: relative;top: -.4rem;right: .5rem;">
          <img src="../assets/images/home/personalTopImgText.png"
               alt="" />
        </div>
        <div class="txt-wrapper">
          <div class="txt-CN"
               style="font-size: 3rem; padding-top: .8rem ;padding-left: .8rem;justify-content: unset">
            <span>广</span><span>东</span><span>省</span><span>干</span><span>部</span><span>培</span><span>训</span><span>网</span><span>络</span><span>学</span><span>院</span>
          </div>
          <div class="txt-CN"
               style="font-size: 3rem; justify-content: unset;padding-top: .8rem ;padding-left: .8rem;position: relative;left: 19rem;"><span style="letter-spacing: 0;">——</span><span>深</span><span>圳</span><span>专</span><span>区</span></div>
          <!-- <div class="txt-ENG">
            <span>GUANG</span>
            <span>DONG</span>
            <span>SHENG</span>
            <span>GAN</span>
            <span>BU</span>
            <span>WANG</span>
            <span>LUO</span>
            <span>PEI</span>
            <span>XUN</span>
            <span>XUE</span>
            <span>YUAN</span>
            <span>—</span>
            <span>SHEN</span>
            <span>ZHEN</span>
            <span>ZHUAN</span>
            <span>QU</span>
          </div> -->
        </div>
      </div>
    </div>

    <div class="navWrap">
      <el-menu :default-active="activeIndex()"
               class="el-menu-nav"
               mode="horizontal"
               @select="handleSelect"
               :router="router">
        <el-menu-item index="/home">首页</el-menu-item>
        <el-menu-item index="/course">课程中心</el-menu-item>
        <!-- <el-submenu index="5">
            <template slot="title">考试</template>
            <el-menu-item index="/examList">考试列表</el-menu-item>
          </el-submenu> -->
        <el-menu-item index="/enterExam">考试</el-menu-item>
        <el-menu-item index="/personal">个人中心</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import cookie from "cookie_js";
import {
  getStudent
} from '@/api/personal'
import {
  getAnnounceNews,
  getKey
} from "@/api/home";
export default {
  name: "menuBar",
  props: ["messageObj"],
  data () {
    return {
      form: {},
      totalMsg: {},
      isSignIn: false,
      dialogVisible: false,
      router: true,
      headerBg: {
        backgroundImage: "url(" + require("../assets/images/shenzhen-header-bg.71c77a4.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      },
      num: 0,
      textArr: ["欢迎来到广东省干部网络学院———深圳专区", "欢迎！"],
    };
  },
  computed: {
    text () {
      return {
        id: this.textArr[this.num].id,
        val: this.textArr[this.num].title,
      };
    },
  },
  created () {
    this.getToken();
  },
  methods: {
    handleReturn () {
      window.location.href = 'https://gbpx.gd.gov.cn/gdceportal/index.aspx';
    },
    // 获取AES加密公钥
    getToken () {
      let localStorageToken = localStorage.getItem("sz_token");
      // localStorageToken = true
      if (localStorageToken) {
        this.isSignIn = true;
        this.SignIn();
      }
    },
    startMove () {
      let timer = setTimeout(() => {
        if (this.num === this.textArr.length - 1) {
          this.num = 0;
        } else {
          this.num += 1;
        }
        this.startMove();
      }, 5000); // 当滚动时间等于2000时 会暂时滚动
    },
    handleRegister () {
      window.location.href = "https://gbpx.gd.gov.cn/gdceportal/regch.aspx";
    },
    handleLogin () {
      window.location.href =
        "https://gbpx.gd.gov.cn/gdceportal/index.aspx?ReturnUrl=%2fgdceportal%2fStudy%2fCourseDetail.aspx%3fid%3d702775745ff44735b2ee144dd59b1007%26type%3dkctj&id=702775745ff44735b2ee144dd59b1007&type=kctj";
    },
    handleReturn () {
      window.location.href = "https://gbpx.gd.gov.cn/gdceportal/index.aspx";
    },
    SignIn () {
      if (!this.isSignIn) {
        return;
      }
      let that = this;
      getStudent().then(res => {
        console.log('=================student info', res)
        this.form = res.data.data;
        // cookie.set('name', res.data.data.name, {
        //   path: '/'
        // });
      })

    },
    SignOut () {
      let that = this;
      that.$axios({
        url: 'https://gbpx.gd.gov.cn/gdceportal/LoginAjaxServer.ashx?sign=LogOut',
        method: 'POST',
        data: {}
      }).then(res => {
        localStorage.removeItem("sz_token");
        localStorage.removeItem("user");
        this.currentUserId = "";
        this.$router.go(0);
        that.$alert('退出成功！', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            window.location.href = 'https://gbpx.gd.gov.cn/gdceportal/index.aspx';
          }
        });
      }).catch(err => {
        console.log(err);
      });
    },
    activeIndex () {
      return this.$route.path;
    },
    handleSelect (key, keyPath) {
      // console.log(key, keyPath);
    },
  },
  mounted () {
    //this.startMove();
  },
};
</script>
<style scoped>
.slide-enter-active {
  transition: all 2s linear;
}

/* .slide-leave-active {
  transition: all .5s linear;
}

.slide-enter {
  transform: translateY(30px);
  opacity: 0;
}
.slide-leave-to {
  transform: translateY(-30px);
  opacity: 0;
} */

.notice {
  height: 40px;
  background: #f6f6f6;
  position: relative;
  overflow: hidden;
}

.notice:hover {
  cursor: pointer;
}

.notice-content {
  margin-left: 15%;
}

.notice-img {
  width: 20px;
  height: 20px;
  margin-top: 10px;
}

.notice-text {
  margin-left: 20px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  text-align: left;
  position: absolute;
  font-size: 0.9rem;
  color: #444444;
  /* top: 9px; */
}

.loginBar,
.userBar {
  position: absolute;
  right: 15%;
  top: 0;
  height: 40px;
  display: flex;
  align-items: center;
}

.loginBar a,
.userBar a {
  text-decoration: none;
  font-size: 0.8rem;
  font-family: Arial;
  /* font-weight: bold; */
  color: #333333;
}

.user-icon-wrapper {
  width: 1vw;
  height: 1vw;
  position: relative;
  margin-right: 10px;
}

.user-icon-wrapper img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.loginBar-devider {
  height: 0.8rem;
  width: 1.5px;
  background: #333;
  margin: 0 10px;
}

.menuBar-container {
}

.topWrap {
  height: 304px;
  background: url(~@/assets/images/shenzhen-header-bg.png) no-repeat;
  background-size: 100% 106%;
  min-width: 1024px;
  display: flex;
  align-items: center;
}

.head-title-wrapper {
  width: 70%;
  margin: 0 auto;
  display: flex;
}

.logo-wrapper {
  width: 70px;
  height: 70px;
  position: relative;
}

.logo-wrapper img {
  width: 112%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 20px;
}

.header-panel-button {
  width: 43vw;
  min-width: 380px;
  display: inline-block;
}

.header-panel-button .el-button {
  font-weight: bold;
}

.txt-wrapper {
  margin-left: 10px;
  width: calc(100% - 70px);
  display: flex;
  flex-direction: column;
  color: #c01a27;
  font-weight: bold;
  min-height: 80px;
}

.txt-CN {
  font-size: 3.5rem;
  display: flex;
  justify-content: space-between;
}

.txt-ENG {
  font-size: 1.2rem;
  display: flex;
  justify-content: space-between;
}

.navWrap {
  min-width: 1024px;
  width: 100%;
  /* background: url(~@/assets/kx/home/nav.png) no-repeat; */
  background: #a60014;
  background-size: 100% 100%;
  height: 45px;
  display: flex;
  justify-content: center;
}

.navWrap .el-menu::before {
  display: none;
}

.navWrap .el-menu::after {
  display: none;
}

.el-menu-nav {
  width: 70%;
  height: 45px;
  display: flex;
  justify-content: space-between;
  background: #a60014;
  /* background: teal; */
}

.el-menu--horizontal >>> .el-submenu__title i {
  color: #fff;
}

.el-menu.el-menu--horizontal,
.el-menu--horizontal >>> .el-submenu .el-submenu__title {
  border-bottom: none;
}

.el-menu--horizontal >>> .el-menu-item:not(.is-disabled):hover {
  background: #970009;
}

.el-menu--horizontal >>> .el-menu-item:focus,
.el-menu--horizontal >>> .el-menu-item:hover,
.el-menu--horizontal >>> .el-menu-item.is-active,
.el-submenu >>> .el-submenu__title:hover,
.el-menu--horizontal >>> .el-submenu.is-active .el-submenu__title {
  border-bottom: none;
  color: #fff;
  background: #970009;
}

.el-menu-nav >>> .el-menu-item {
  height: 45px;
  line-height: 45px;
  color: #fff;
  /* width: 11.44vw; */
  text-align: center;
  /* margin-right: 1.44vw; */
  font-size: 1.5rem;
}

.el-menu--horizontal >>> .el-menu-item {
  border-bottom: none;
}

.el-menu-nav >>> .el-menu-item:first-child {
  /* width: 6.44vw;

  min-width: 65px; */
  /* margin-right: 1.44vw; */
}

.el-menu-nav >>> .el-menu-item:last-child {
  /* width: 10vw;
  min-width: 107px; */
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuBar.vue



// WEBPACK FOOTER //
// src/components/MenuBar.vue